import getDefaultMenu, { getMenuProps as defaultGetMenuProps } from '../../components/Post/menu'
import capitalize from '../../utils/capitalize'

// Csak az `edit` és `delete` menüpontot tartjuk meg.
// A `ban`, `approve`, `protection` (kiemelés), `removeProtection` resolvereket
// szerver oldalon le vannak tiltva, ezért a kliens menüből is kivesszük őket.
const ENABLED_KEYS = ['edit', 'delete']

export function getMenuProps(p) {
    return defaultGetMenuProps(p)
}

function getMenu(props = {}) {
    const N = capitalize(props.name)
    const enabledLabels = ENABLED_KEYS.map((k) => props.appContext.menus[k + N + 'Menu'])

    return getDefaultMenu(props).filter((menu) => enabledLabels.includes(menu.label))
}

export default getMenu
